import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Form, Button, Message, Image } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import settings from "../../settings";
import eye from "../../assets/images/eye.jpg";
import closedeye from "../../assets/images/closedeye.png";
import { getTermsOfUseLink } from "../../utils/PageHelper";

function isSpecialChar(letter) {
  const charInt = letter.charCodeAt(0);
  const allowedLettersRange = "AZaz09";
  if (charInt >= allowedLettersRange.charCodeAt(0) && charInt <= allowedLettersRange.charCodeAt(1))
    return false;
  if (charInt >= allowedLettersRange.charCodeAt(2) && charInt <= allowedLettersRange.charCodeAt(3))
    return false;
  if (charInt >= allowedLettersRange.charCodeAt(4) && charInt <= allowedLettersRange.charCodeAt(5))
    return false;
  return true;
}

function isAllowedSpecialChar(letter) {
  const allowedLettersRange = "!-.?[]_`~:!@#$%^&*+=";
  if (allowedLettersRange.indexOf(letter) > -1)
    return true;
  return false;
}

function validatePassword(password) {
  let error = "";
  const passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/;
  if (!passw.test(password))
    error =
      "Must contain at least one numeric digit, one uppercase and one lowercase!";
  if (password && password.length > 0) {
    if (password.length > 16) {
      error = "Maximum password length is exceeded";
    }
    if (password.indexOf('-') === 0 || password.indexOf('.') === 0) {
      error = `Passwords cannot starts with the character "${password[0]}"`;
    }
    let prevLetter = '';
    let hasConsecutiveLetters = false;
    let unallowedCharError = "";
    let specialLettersCount = 0;
    _.forEach(password, letter => {
      if (isSpecialChar(letter)) {
        if (!isAllowedSpecialChar(letter)) {
          unallowedCharError = `Passwords cannot contains the character ${letter}`;
        }
        specialLettersCount += 1;
      }
      if (prevLetter !== "" && isSpecialChar(prevLetter) && isSpecialChar(letter))
        hasConsecutiveLetters = true;
      prevLetter = letter;
    });
    if (unallowedCharError !== "") {
      error = unallowedCharError;
    }
    else if (specialLettersCount > 3) {
      error = "Max 3 special characters allowed";
    }
    else if (hasConsecutiveLetters) {
      error = "Consecutive special characters not allowed";
    }
  }
  return error;
}

class ChangePasswordForm extends React.Component {
  state = {
    data: {
      password: "",
      confirmpassword: "",
      username: "",
      termscheck: "",
      appname: settings.appName,
    },
    loading: false,
    hidePassword: true,
    errors: {},
  };

  onChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });

  onPasswordChage = (e) => {
    const { data } = this.state;
    data[e.target.name] = e.target.value;
    this.setState({ data });
    this.validatePasswords(data);
  }

  onTermsChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.checked },
    });

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      this.props
        .submit(this.state.data)
        .then(() => this.setState({ loading: false }))
        .catch((err) => {
          this.setState({ errors: err.response.data.errors, loading: false });
        });
    }
  };

  validatePasswords = (data) => {
    const { errors } = this.state;
    errors.password = validatePassword(data.password);
    errors.confirmpassword = "";
    if (data.confirmpassword && data.confirmpassword.length > 0 && data.password !== data.confirmpassword) {
      errors.confirmpassword = "Passwords Do Not Match!";
    }
    this.setState({ errors });
  };


  validate = (data) => {
    const errors = {};
    if (!data.username) errors.username = "User ID cannot be blank";
    const passwordError = validatePassword(data.password);
    if (passwordError !== "")
      errors.password = validatePassword(data.password);
    if (data.confirmpassword && data.confirmpassword.length > 0 && data.password !== data.confirmpassword) {
      errors.confirmpassword = "Passwords Do Not Match!";
    }
    if (!data.termscheck) errors.termscheck = "Please check the terms box";
    return errors;
  };

  togglePasswordType = (toggle) => {
    this.setState({ hidePassword: toggle });
  };

  render() {
    const { data, errors, loading } = this.state;
    const termsOfUseUrl = getTermsOfUseLink();
    return (
      <Form onSubmit={this.onSubmit} loading={loading}>
        {(errors.global || this.props.changePasswordError) && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{errors.global || this.props.changePasswordError}</p>
          </Message>
        )}
        <Form.Field>
          <ul>
            <li>Password must be at least a minimum of 8 characters and a maximum of 16 characters</li>
            <li>
              Password must contain at least one numeric digit, one uppercase and one lowercase
            </li>
            <li>
              Password can have a maximum of 3 special characters however, consecutive special
              characters are not allowed
            </li>
            <li>Passwords are case sensitive</li>
            <li>Passwords used previously will not be accepted</li>
          </ul>
        </Form.Field>
        <Form.Field error={!!errors.username}>
          <label className="font-family" htmlFor="username">
            User ID:
          </label>
          <input
            type="text"
            id="username"
            name="username"
            tabIndex="a"
            autoComplete="username"
            placeholder="Enter your user ID"
            value={data.username}
            onChange={this.onChange}
          />
          {errors.username && <InlineError text={errors.username} />}
        </Form.Field>
        <Form.Field error={!!errors.password}>
          <label className="font-family" htmlFor="password">
            Password:
          </label>
          <input
            type={this.state.hidePassword ? "password" : "text"}
            id="password"
            name="password"
            tabIndex="b"
            autoComplete="current-password"
            placeholder="Enter your password"
            value={data.password}
            className="col-md-1"
            onChange={this.onPasswordChage}
          />
          {errors.password && <InlineError text={errors.password} />}
        </Form.Field>
        <Form.Field error={!!errors.confirmpassword}>
          <label className="font-family" htmlFor="password">
            Confirm Password:
          </label>
          <input
            type={this.state.hidePassword ? "password" : "text"}
            id="confirmpassword"
            name="confirmpassword"
            tabIndex="c"
            autoComplete="confirm-password"
            placeholder="Confirm your password"
            value={data.confirmpassword}
            className="col-md-1"
            onChange={this.onPasswordChage}
          />
          {this.state.hidePassword ? (
            <Image
              src={eye}
              inline
              className={"display-icon"}
              onClick={() => this.togglePasswordType(false)}
            />
          ) : (
            <Image
              src={closedeye}
              inline
              className={"display-icon"}
              onClick={() => this.togglePasswordType(true)}
            />
          )}
          {errors.confirmpassword && (
            <InlineError text={errors.confirmpassword} />
          )}
        </Form.Field>
        <Form.Field error={!!errors.termscheck}>
          <label className="font-family padding-top-20" htmlFor="termscheck">
            <input
              type="checkbox"
              id="termscheck"
              tabIndex="d"
              name="termscheck"
              value={data.termscheck}
              onChange={this.onTermsChange}
            />
            &nbsp;By checking this box, I hereby approve and agree to abide by
            the
            <a
              href={termsOfUseUrl}
              alt="Link to the Terms and conditions pdf which opens in a new tab"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Terms of Use
            </a>{" "}
            as set forth in the original Service Agreement and as amended from
            time to time
          </label>
          {errors.termscheck && <InlineError text={errors.termscheck} />}
        </Form.Field>
        <Button
          primary
          disabled={!(data.username && data.password && data.confirmpassword)}
        >
          Create Password
        </Button>
      </Form>
    );
  }
}

ChangePasswordForm.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default ChangePasswordForm;



// WEBPACK FOOTER //
// ./src/components/forms/ChangePasswordForm.js